import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import {RestService} from "../immerdrin/rest.service.interface";
import {RestServiceImpl} from "../immerdrin/rest.service.impl";
import {LoggerService} from "../../shared/logger.service";
// import {DragulaService} from "ng2-dragula";
import {AuthService} from "../../shared/auth.service";
import {InsertEditMitDialogs} from "../immerdrin/bearbeitung/insertEdit.mitDialogs";
import {
	L10nTranslatePipe,
	L10N_LOCALE, L10nLocale, L10N_CONFIG, L10nConfig, L10nTranslationService
} from 'angular-l10n';
import {APIConfigService} from "../../api.config.service"; import {AngularMaterial2Module} from "../../app.module.material";
import {HttpClient} from "@angular/common/http";
import {FormsModule} from "@angular/forms";
import {NgxPasswordStrengthBarComponent, NgxPasswordStrengthBarModule} from "ngx-password-strength-bar";
// import {PasswordStrengthMeterComponent, PasswordStrengthMeterModule} from 'angular-password-strength-meter';

const PATH_FILE = 'app/protected/kernbenutzer/kernbenutzer.insertEdit.component.ts';

@Component({
    selector: 'oase-kernbenutzer-passwordChange.dialog',
    templateUrl: './kernbenutzer.passwordChange.component.html',
    providers: [{ provide: RestService, useExisting: RestServiceImpl }],
    standalone:true,
	imports: [AngularMaterial2Module, L10nTranslatePipe, FormsModule, NgxPasswordStrengthBarModule ]
	// imports: [AngularMaterial2Module, L10nTranslatePipe, FormsModule ]

})
export class KernbenutzerPasswordChangeComponent extends InsertEditMitDialogs {

    constructor(
        public dialogRef: MatDialogRef<KernbenutzerPasswordChangeComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dataService: RestService,
        public authService: AuthService,
		public apiConfigService: APIConfigService,
		public http: HttpClient,
        public dialog: MatDialog,
		@Inject(L10N_LOCALE) public locale: L10nLocale,
		@Inject(L10N_CONFIG) private config: L10nConfig,
		public translation: L10nTranslationService,
        public _logger: LoggerService) {

        super(dialogRef, data, dataService, authService, apiConfigService, http, dialog, _logger);

    }

    getPasswortStaerke(passwort: string = "") : string {
        return this.translation.translate('allgemein.validierung.passwort.' + (new NgxPasswordStrengthBarComponent()).getStrengthIndexAndColor(passwort).idx);
    }

	onPasswordStrengthChanged(data) {
		console.log("strength: "+data);

	}
}
